import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, User, FileText } from 'lucide-react';

interface ModalSucessoFechamentoProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pedidoNumero: string;
  bkoNome: string | null;
  onVerPedido: () => void;
}

export function ModalSucessoFechamento({
  open,
  onOpenChange,
  pedidoNumero,
  bkoNome,
  onVerPedido
}: ModalSucessoFechamentoProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] z-[10250]">
        {/* Ícone de sucesso grande */}
        <div className="flex flex-col items-center gap-4 py-6">
          <div className="rounded-full bg-success/10 p-4">
            <CheckCircle className="h-16 w-16 text-success" />
          </div>
          
          {/* Título */}
          <div className="text-center">
            <h2 className="text-2xl font-bold text-success">
              Pedido Fechado com Sucesso!
            </h2>
            <p className="text-muted-foreground mt-2">
              O pedido foi processado e está pronto para tramitação
            </p>
          </div>

          {/* Informações */}
          <div className="w-full space-y-3 bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <FileText className="h-5 w-5 text-primary" />
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Número do Pedido
                </p>
                <p className="text-lg font-bold">
                  #{pedidoNumero}
                </p>
              </div>
            </div>

            {bkoNome && (
              <div className="flex items-center gap-3 border-t pt-3">
                <User className="h-5 w-5 text-primary" />
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Enviado para BKO
                  </p>
                  <p className="text-lg font-bold">
                    {bkoNome}
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Botões de ação */}
          <div className="flex gap-3 w-full mt-4">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => onOpenChange(false)}
            >
              Fechar
            </Button>
            <Button
              className="flex-1"
              onClick={onVerPedido}
            >
              Ver Pedido
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
